import { Component } from '@angular/core';
import { ApplicationConstants } from '../../helpers/application-constants.helper';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
    selector: 'spv2-grid-string-filter',
    templateUrl: './grid-string-filter.component.html',
    styleUrls: ['./grid-string-filter.component.scss'],
    standalone: false
})
export class GridStringFilterComponent extends GridFilterBase<string> {
  debounceTime = ApplicationConstants.debounceTimeInMilliSeconds;
}
